import {
  isCenterProfilePageType,
  isFacetPageType,
  isLocationPageType,
  isTaxonomyPageType
} from '../../domain/useCases/pageTypeCheck'
import { PageType } from '../../types/models/PageType.model'
import {
  Location,
  LocationAllowList,
  LOCATION_TYPE_TITLE
} from '@/types/models/Location.model'
import { Term, Center } from '@/types/models'
import { isObject } from '@/utils/checks'
import computeFacetBreadCrumbs from './computeFacetBreadCrumbs'
import computeLocationBreadCrumbs from './computeLocationBreadCrumbs'
import computeCenterBreadCrumbs from './computeCenterBreadCrumbs'
import computeTermPageBreadCrumbs from './computeTermPageBreadCrumbs'
import { orderLocationsByType } from '@/domain/location'
import { filterBreadcrumbsForDisallowedRegions } from '@/domain/useCases/filterBreadcrumbsForDisallowedRegions'
import { BreadCrumb } from '@/types/models'

export type BreadCrumbs = (Center | Location | Term | BreadCrumb)[]

interface ComputeBreadCrumbs {
  (props: {
    center?: Center
    location?: Location
    pageType: PageType
    term?: Term
    isV2?: boolean
    locationAllowList: LocationAllowList
  }): { breadCrumbs: BreadCrumbs; selectedTitle: string }
}

const computeBreadCrumbs: ComputeBreadCrumbs = ({
  center,
  location,
  pageType,
  term,
  locationAllowList
}) => {
  let computedBreadCrumbs: { breadCrumbs: BreadCrumbs; selectedTitle: string } =
    {
      breadCrumbs: [],
      selectedTitle: ''
    }

  if (isFacetPageType(pageType) && isObject(term) && isObject(location)) {
    computedBreadCrumbs = computeFacetBreadCrumbs({ location, term })
  } else if (isLocationPageType(pageType) && isObject(location)) {
    computedBreadCrumbs = computeLocationBreadCrumbs({ location })
  } else if (isCenterProfilePageType(pageType) && isObject(center)) {
    computedBreadCrumbs = computeCenterBreadCrumbs({
      center,
      locationAllowList
    })
  } else if (isTaxonomyPageType(pageType) && isObject(term)) {
    computedBreadCrumbs = computeTermPageBreadCrumbs({ term })
  }

  computedBreadCrumbs.breadCrumbs = orderLocationsByType(
    filterBreadcrumbsForDisallowedRegions(
      computedBreadCrumbs.breadCrumbs as BreadCrumb[]
    )
  ) as BreadCrumbs

  return computedBreadCrumbs
}

export default computeBreadCrumbs
